module.exports = __webpack_public_path__ + "Fowl.bc6ba19.glb";